import useEnvVar from './useEnvVar';
export default useEnvVar;
